import React from 'react';
import { IconCheck, IconX } from './Icons';
import { useLanguage } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './ComparisonSection.css';

const ComparisonSection = () => {
  const { t } = useLanguage();
  const othersItems = [
    t.comparisonSection.others1,
    t.comparisonSection.others2,
    t.comparisonSection.others3,
    t.comparisonSection.others4,
    t.comparisonSection.others5,
    t.comparisonSection.others6,
  ];

  const usItems = [
    <><strong>{t.comparisonSection.us1}</strong>{t.comparisonSection.us1End}</>,
    <>{t.comparisonSection.us2Start} <strong>{t.comparisonSection.us2Bold}</strong></>,
    <><strong>{t.comparisonSection.us3Bold}</strong>{t.comparisonSection.us3End}</>,
    <>{t.comparisonSection.us4Start} <strong>{t.comparisonSection.us4Bold}</strong>{t.comparisonSection.us4End}</>,
    <><strong>{t.comparisonSection.us5Bold}</strong>{t.comparisonSection.us5End}</>,
    <>{t.comparisonSection.us6Start} <strong>{t.comparisonSection.us6Bold}</strong></>,
  ];

  const headerReveal = useScrollReveal({ threshold: 0.2 });
  const othersReveal = useScrollReveal({ threshold: 0.1 });
  const usReveal = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="comparison-fox">
      <div className="comparison-fox__container">
        <div ref={headerReveal.ref} className={`comparison-fox__header reveal ${headerReveal.isRevealed ? 'reveal--visible' : ''}`}>
          <span className="comparison-fox__label">{t.comparisonSection.label}</span>
          <h2 className="comparison-fox__title">{t.comparisonSection.title}</h2>
        </div>
        <div className="comparison-fox__grid">
          <div ref={othersReveal.ref} className={`comparison-fox__column comparison-fox__column--others reveal--left ${othersReveal.isRevealed ? 'reveal--visible' : ''}`}>
            <div className="comparison-fox__column-header">
              <span className="comparison-fox__column-title">{t.comparisonSection.othersTitle}</span>
            </div>
            <ul className="comparison-fox__list">
              {othersItems.map((item, index) => (
                <li key={index} className="comparison-fox__item comparison-fox__item--negative">
                  <span className="comparison-fox__icon"><IconX size={16} /></span>
                  <span className="comparison-fox__text">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="comparison-fox__divider"><span className="comparison-fox__divider-text">vs</span></div>
          <div ref={usReveal.ref} className={`comparison-fox__column comparison-fox__column--us reveal--right ${usReveal.isRevealed ? 'reveal--visible' : ''}`}>
            <div className="comparison-fox__column-header">
              <span className="comparison-fox__column-title">{t.comparisonSection.usTitle}</span>
            </div>
            <ul className="comparison-fox__list">
              {usItems.map((item, index) => (
                <li key={index} className="comparison-fox__item comparison-fox__item--positive">
                  <span className="comparison-fox__icon"><IconCheck size={16} /></span>
                  <span className="comparison-fox__text">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
